import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-sms-code',
  templateUrl: './sms-code.component.html',
  styleUrls: ['./sms-code.component.sass']
})
export class SmsCodeComponent implements OnInit {
  public prepaidtoken
  public token;
  public code;
  public accountId;
  constructor(private loadingScreenService :LoadingScreenService,private services: Service,private global:GlobalService,public matDialogRef:MatDialogRef<SmsCodeComponent>,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) { 
    if(data.accountId!=undefined){
      this.accountId=data.accountId;
    }
  }

  ngOnInit() {
    this.token=sessionStorage.getItem("token");
  }
  resendCode(){
    if(this.global.validateSession()===true){
    this.global.notif("SMS con códigos de verificación ha sido enviado.");
    this.prepaidtoken=this.token;    
    this.global.notif("resendCode");
    //this.loadingScreenService.startLoading();
    // this.services.resendCode(this.token).subscribe(data => {
    //   if(data.success==true){
    //       this.loadingScreenService.stopLoading();
    //     }
    //     else{
    //         this.loadingScreenService.stopLoading();
    //         this.global.notif(data.error);
    //     }
    // });
    }
  }
  validatecode(){
    if(this.global.validateSession()===true){
      this.prepaidtoken=this.token;
      if(this.code==""||this.code==null||this.code==undefined){
          this.global.notif("debe colocar el codigo de verificación.");
      }
      else if(this.code.length!=8){
          this.global.notif("Debe ingresar al menos 8 numeros.");
      }
      else{
          this.loadingScreenService.startLoading();
          this.services.codeValidate(this.prepaidtoken,this.code).subscribe(data => {
              if(data.success==true){
                  
                      this.services.addSubscriber(this.prepaidtoken,this.accountId).subscribe(data => {//suscriptorId
                          if(data.success==true){
                            this.loadingScreenService.stopLoading();
                          }
                          else{
                              this.loadingScreenService.stopLoading();
                              this.global.notif(data.error);
                          }
                      });
              }
              else{
                this.loadingScreenService.stopLoading();
                  this.global.notif(data.error);
              }
          });
      }
    }
  }
  public close(){
    if(this.global.validateSession()===true){
      this.matDialogRef.close('cancel');
    }
  }
}
